<template>
  <template v-if="video">
    <template v-if="video.role">
      <div class="text-xs text-gray-700 font-medium truncate">{{ video.role.name }}</div>
    </template>
    <template v-else>
      <!-- <template v-if="video.role_slug === 'yousei_jitsugi02,yousei_online02'">
        <div class="text-xs text-gray-700 font-medium truncate">養成講座2期（実技）</div>
      </template> -->
      <template v-if="video.role_slug === 'default_history_qa'">
        <div class="text-xs text-gray-700 font-medium truncate">過去の質疑応答</div>
      </template>
      <template v-if="video.role_slug === 'default'">
        <div class="py-2"></div>
      </template>
    </template>
    <div class="relative">
      <template v-if="Array.isArray(video.video_completions) && video.video_completions.length">
        <div class="absolute z-10 top-0 right-0">
          <img class="pt-1 pr-1 w-8" src="@/assets/images/completed.png" alt="済">
        </div>
      </template>
      <div
        class="aspect-w-16 aspect-h-9"
      >
        <template v-if="thumbnailUrl === undefined">
          <iframe loading="lazy" :src="video.embed_url" frameborder="0" class="pointer-events-none w-full" />
        </template>
        <template v-else>
          <img loading="lazy" :src="thumbnailUrl" alt="thumbnail" class="w-full">
        </template>
      </div>
      <div :class="`text-gray-700 text-sm font-medium truncate mt-1 ${titleAlign}`">{{ video.title }}</div>
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, onMounted } from 'vue'

import { VideoAttributes } from '@/types/models/video'
import { toArray } from '@/utils/array'
import { axios } from '@/plugins/axios'
import axiosBase from 'axios'

const fetchVimeoThumbnailUrl = async (vimeoId: string, vimeoHash: string): Promise<string | undefined> => {
  const vimeoApiUrl = `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${vimeoId}/${vimeoHash}`
  const response = await axiosBase.get(vimeoApiUrl)
  // response.data.thumbnail_urlはundefinedの可能性がある
  return response.data ? response.data.thumbnail_url : undefined
}

const updateThumbnailUrl = (videoId: number, thumbnailUrl: string) => {
  axios.post(`/video/thumbnail/${videoId}`, { thumbnail_url: thumbnailUrl })
}

export default defineComponent({
  props: {
    video: {
      type: Object as PropType<VideoAttributes | undefined>,
      'default': () => (undefined),
    },
    titleAlign: {
      type: String,
      'default': () => ('text-left'),
    },
  },
  setup(props) {
    const thumbnailUrl = ref<string | undefined>(undefined)

    const getThumbnailUrl = async (video: VideoAttributes | undefined): Promise<string | undefined> => {
      if (video) {
        if (video.thumbnail_url) return video.thumbnail_url
  
        if (video.video_vimeo) {
          const thumbnailUrl = await fetchVimeoThumbnailUrl(video.video_vimeo.vimeo_id, video.video_vimeo.vimeo_hash)
          if (thumbnailUrl) updateThumbnailUrl(video.id, thumbnailUrl) //初回のみVimeoAPIを叩きたいためDBに保存する
          return thumbnailUrl
        }
      }

      return undefined
    }

    onMounted(async () => {
      thumbnailUrl.value = await getThumbnailUrl(props.video)
    })

    return {
      toArray,
      thumbnailUrl,
    }
  },
})
</script>
